// Just some symbols

export const symbols = {
    ellipsis: '…',
    function: 'ƒ'
};